import { isProtectedCardProduct } from '../../../app/Libraries/ProductCardAvailability';

/** Resolve the existing native PDP contact trigger; protected/legacy pages stay unchanged. */
export function productCardInquiryTrigger(doc: Document, location: Pick<Location, 'pathname' | 'hash'>): HTMLElement | null {
  if (location.hash !== '#modal-contact') return null;
  const main = doc.querySelector('main[data-watch-buying="product"], main[data-jewellery-buying="product"]');
  const product = main?.querySelector<HTMLElement>('.js-product[data-product]');
  if (!main || !product || main.querySelector('.js-request-purchase')
    || isProtectedCardProduct({ brand: product.dataset.brand, handle: product.dataset.product }, location.pathname)
    || !doc.querySelector('.js-modal[data-modal="contact"]')) return null;
  return main.querySelector<HTMLElement>('.js-modal-btn[data-modal="contact"]');
}
